<div class="dialog-container">
    <div *ngIf="!isLoading" class="report-wrapper" id="print-area">
        <table class="ledger-table" id="business-report-table">
            <thead>
                <tr class="main-header">
                    <th colspan="3" class="header-title">जाहिरात विभाग - वर्ष {{ displayYear }} करिता उद्दीष्ट नियोजन
                    </th>

                    <th colspan="2" class="input-header-cell">
                        दिलेले उद्दिष्ट-
                        <input type="number" [(ngModel)]="givenTarget" (input)="updateCalculations()"
                            class="header-input">
                    </th>

                    <th colspan="2" class="input-header-cell">
                        पूर्ण उद्दिष्ट-
                        <input type="number" [ngModel]="purtataTotal" readonly class="header-input">
                    </th>

                    <th colspan="2">
                        बाकी उद्दिष्ट- {{ remainingAmount }}
                    </th>

                    <th rowspan="2" class="vertical-header">एकूण व्यवसाय</th>
                </tr>

                <tr class="sub-header" style="text-align: end;">
                    <th colspan="3" class="user-name">{{ data.repname}}</th>
                    <th>नियोजन-</th>
                    <th>{{ niyojanTotal }}</th>
                    <th>टक्के-</th>
                    <th>{{ achievementPercent }}%</th>
                    <th>टक्के-</th>
                    <th>{{ remainingPercent }}%</th>
                </tr>

                <tr class="column-labels">
                    <th style="width: 40px;">अ.क्र.</th>
                    <th>तपशील</th>
                    <th>नियोजन</th>
                    <th style="background-color: #fff9c4;">उद्दीष्ट</th>
                    <th style="background-color: #e1f5fe;">पूर्तता</th>
                    <th>पुढील वर्षासाठी</th>
                    <th>वापरले(आजअखेर)</th>
                    <th>वापरणे बाकी</th>
                    <th>व्यवसाय</th>
                </tr>
            </thead>

            <tbody>
                <!-- Static rows BEFORE all categories -->
                <tr class="section-row" style="background-color: #e3f2fd;">
                    <td colspan="9" class="text-left">
                        <b>अ) &nbsp; इतर</b>
                    </td>
                </tr>

                <tr>
                    <td>1</td>
                    <td class="text-left">वार्षिक करार</td>
                    <td><input type="number" [(ngModel)]="staticData.varshikKarar.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.varshikKarar.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.varshikKarar.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.varshikKarar.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.varshikKarar.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.varshikKarar) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.varshikKarar.total_business || 0 }}</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td class="text-left">प्रासंगिक जाहिराती</td>
                    <td><input type="number" [(ngModel)]="staticData.prasangikJahirati.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.prasangikJahirati.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.prasangikJahirati.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.prasangikJahirati.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.prasangikJahirati.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.prasangikJahirati) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.prasangikJahirati.total_business || 0 }}
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td class="text-left">नियिमित विशेषांक</td>
                    <td><input type="number" [(ngModel)]="staticData.niyimitVisheshank.niyojan"
                            (input)="updateCalculations()" class="table-input"></td>
                    <td><input type="number" [(ngModel)]="staticData.niyimitVisheshank.uddishth"
                            (input)="updateCalculations()" class="table-input"></td>
                    <td style="text-align: end;">{{ staticData.niyimitVisheshank.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.niyimitVisheshank.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.niyimitVisheshank.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.niyimitVisheshank) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.niyimitVisheshank.total_business || 0 }}
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td class="text-left">ग्रंथ</td>
                    <td><input type="number" [(ngModel)]="staticData.sang.niyojan" (input)="updateCalculations()"
                            class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.sang.uddishth" (input)="updateCalculations()"
                            class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.sang.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.sang.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.sang.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.sang) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.sang.total_business || 0 }}</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td class="text-left">विशेष पुरवणी</td>
                    <td><input type="number" [(ngModel)]="staticData.visheshPurvani.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.visheshPurvani.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.visheshPurvani.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.visheshPurvani.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.visheshPurvani.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.visheshPurvani) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.visheshPurvani.total_business || 0 }}
                    </td>
                </tr>
                <tr>
                    <td>6</td>
                    <td class="text-left">देणगी</td>
                    <td><input type="number" [(ngModel)]="staticData.dengi.niyojan" (input)="updateCalculations()"
                            class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.dengi.uddishth" (input)="updateCalculations()"
                            class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.dengi.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.dengi.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.dengi.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.dengi) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.dengi.total_business || 0 }}</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td class="text-left">कार्यक्रम माध्यम</td>
                    <td><input type="number" [(ngModel)]="staticData.karyakramMadhyam.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="staticData.karyakramMadhyam.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ staticData.karyakramMadhyam.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.karyakramMadhyam.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ staticData.karyakramMadhyam.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(staticData.karyakramMadhyam) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ staticData.karyakramMadhyam.total_business || 0 }}
                    </td>
                </tr>

                <!-- Total for static rows -->
                <tr class="category-total-row" style="background-color: #bbdefb;">
                    <td colspan="2"><b>एकूण इतर</b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('niyojan') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('uddishth') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('purtata') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('next_year') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('used_till_date') }}</b></td>
                    <td style="text-align: end;"><b></b></td>
                    <td style="text-align: end;"><b>{{ calculateStaticTotal('total_business') }}</b></td>
                </tr>

                <!-- Now the dynamic categories with colors -->
                <ng-container *ngFor="let category of allCategories; let idx = index">
                    <tr class="section-row" [style.background-color]="getCategoryHeaderColor(idx)">
                        <td colspan="9" class="text-left">
                            <b>{{ getCategoryLabel(idx) }}) &nbsp; {{ category.category_name | slice:0:25 }}</b>
                        </td>
                    </tr>

                    <tr *ngFor="let row of category.monthly_data; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td class="text-left">{{ row.month }}</td>
                        <td><input type="number" [(ngModel)]="row.niyojan" (input)="updateCalculations()"
                                class="table-input"></td>
                        <td>
                            <input type="number" [(ngModel)]="row.uddishth" (input)="updateCalculations()"
                                class="table-input">
                        </td>
                        <td style="text-align: end;">{{ row.purtata || 0 }}</td>
                        <td style="text-align: end;">{{ row.next_year || 0 }}</td>
                        <td style="text-align: end;">{{ row.used_till_date || 0 }}</td>
                        <td style="text-align: end;">{{ calculateRemaining(row) }}</td>
                        <td style="text-align: end;" class="bg-grey">{{ row.total_business || 0 }}</td>
                    </tr>

                    <tr class="category-total-row" [style.background-color]="getCategoryTotalColor(idx)">
                        <td colspan="2"><b>एकूण {{ category.category_name }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data, 'niyojan')
                                }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data, 'uddishth')
                                }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data, 'purtata')
                                }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data, 'next_year')
                                }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data,
                                'used_till_date') }}</b></td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotalRemaining(category.monthly_data) }}</b>
                        </td>
                        <td style="text-align: end;"><b>{{ calculateCategoryTotal(category.monthly_data,
                                'total_business') }}</b></td>
                    </tr>
                </ng-container>
                <!-- Bottom Summary Rows -->
                <tr class="section-row" style="background-color: #e3f2fd;">
                    <td colspan="9" class="text-left">
                        <b>एकूण सारांश</b>
                    </td>
                </tr>

                <tr>
                    <td>1</td>
                    <td class="text-left">नियमित अंक - करार</td>
                    <td><input type="number" [(ngModel)]="bottomData.niyamitAnkKarar.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="bottomData.niyamitAnkKarar.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkKarar.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkKarar.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkKarar.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(bottomData.niyamitAnkKarar) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ bottomData.niyamitAnkKarar.total_business || 0 }}
                    </td>
                </tr>

                <tr>
                    <td>2</td>
                    <td class="text-left">नियमित अंक - प्रासंगिक</td>
                    <td><input type="number" [(ngModel)]="bottomData.niyamitAnkPrasangik.niyojan"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td><input type="number" [(ngModel)]="bottomData.niyamitAnkPrasangik.uddishth"
                            (input)="updateCalculations()" class="table-input" style="text-align: end;"></td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkPrasangik.purtata || 0 }}</td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkPrasangik.next_year || 0 }}</td>
                    <td style="text-align: end;">{{ bottomData.niyamitAnkPrasangik.used_till_date || 0 }}</td>
                    <td style="text-align: end;">{{ calculateStaticRemaining(bottomData.niyamitAnkPrasangik) }}</td>
                    <td style="text-align: end;" class="bg-grey">{{ bottomData.niyamitAnkPrasangik.total_business || 0
                        }}</td>
                </tr>

                <!-- शिलतार करार -->
                <tr class="section-row" style="background-color: #ffecb3;">
                    <td colspan="9" class="text-left">
                        <b>शिलतार करार</b>
                    </td>
                </tr>

                <tr>
                    <td colspan="2" class="text-left"><b>एकूण व्यवसाय</b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('niyojan') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('uddishth') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('purtata') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('next_year') }}</b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('used_till_date') }}</b></td>
                    <td style="text-align: end;"><b></b></td>
                    <td style="text-align: end;"><b>{{ calculateGrandTotal('total_business') }}</b></td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="dialog-actions no-print">
        <button mat-raised-button color="primary" (click)="printPageA4Portrait()" [disabled]="isLoading">Print</button>
        <button mat-raised-button color="accent" (click)="exportToExcel()" [disabled]="isLoading">Export to
            Excel</button>
        <button mat-button (click)="closeDialog()">बंद करा</button>
    </div>
</div>